<template>
    <div>
        <v-dialog v-model="mostrar" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Agregar comentario</v-card-title>
                <v-card-text>
                    <v-textarea
                        v-model="comentario"
                        label="Comentario"
                        :error-messages="comentarioErrors"
                        @input="$v.comentario.$touch()"
                        @blur="$v.comentario.$touch()"
                    ></v-textarea>
                </v-card-text>
                <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue-grey darken-1" small outlined text @click="$emit('cancelar')">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" small dark  @click="agregarComentario()">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    props: ['mostrar','tipoOficio','idOficio'],
    mixins: [validationMixin],
    computed:{
        ...mapGetters([
            "httpURL", 
            "sessionToken",
            "userId"
        ]),
        comentarioErrors() {
            const errors = [];
            if (!this.$v.comentario.$dirty) return errors;
            !this.$v.comentario.required && errors.push("Campo requerido.");
            return errors;
        },
    },
    data: () => ({
        loading: false,
        comentario: null
    }),
    validations:{
        comentario: { required }
    },
    methods:{
        agregarComentario(){
            this.loading = true;
            axios.post(this.httpURL+'/oficios/'+this.tipoOficio+'/comentario/'+this.idOficio,
                {comentario: this.comentario},
                {headers:{token:this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    if( res.data.ok ){
                        // console.log(res.data);
                        this.$emit('comentarioAgregado',res.data.nuevoComentario);
                    }else{
                        this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    // console.log('Error: '+error);
                    this.loading = false;
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
                });

        }
    }
}
</script>